import { DocumentationTranslationKeys } from 'intl/keys';
import type { TranslationKey } from 'intl/types/translationKey';
import { VersionState } from 'shared/domain/documentation/versionState';

const VERSION_STATE_LABEL_KEYS: Record<VersionState, TranslationKey> = {
  [VersionState.current]: DocumentationTranslationKeys.versionStateCurrent,
  [VersionState.outdated]: DocumentationTranslationKeys.versionStateOutdated,
  [VersionState.withdrawn]: DocumentationTranslationKeys.versionStateWithdrawn,
};

/** What a version is to its documentation: current, outdated or withdrawn (PT-7117). */
export function versionStateLabelKey(state: VersionState): TranslationKey {
  return VERSION_STATE_LABEL_KEYS[state];
}
